import React from "react";
import { Input } from "./_shared";
import { Trash2 } from "lucide-react";

export default function BillingTab({ settings, setSettings, saveDisclosure, savePayment, saveReservationFields }) {
  return (
    <>
      {/* Disclosure */}
      <section className="card-surface p-5 sm:p-8 mb-6" data-testid="disclosure-section">
        <h2 className="font-serif text-xl sm:text-2xl mb-2">Afisare date proprietar (granular)</h2>
        <p className="text-xs mb-6" style={{ color: "var(--brand-text-secondary)" }}>
          Pentru fiecare document/canal, alege daca datele de contact ale proprietarului apar in continutul trimis catre client.
        </p>
        <div className="flex flex-col gap-3 mb-6">
          {[
            ["contract", "Contract PDF"],
            ["invoice_pdf", "Factura PDF"],
            ["invoice_email", "Factura (email)"],
            ["approve_email", "Email aprobare client"],
            ["sms", "SMS aprobare client"],
          ].map(([k, label]) => (
            <label key={k} className="flex items-center gap-2 text-sm cursor-pointer">
              <input type="checkbox" checked={!!(settings.disclosure || {})[k]} onChange={(e) => setSettings({...settings, disclosure: {...(settings.disclosure || {}), [k]: e.target.checked}})} data-testid={`disclosure-${k}`} />
              Afiseaza in <b>{label}</b>
            </label>
          ))}
        </div>
        <button onClick={saveDisclosure} className="btn-gold-filled" data-testid="save-disclosure">Salveaza</button>
      </section>

      {/* Payment */}
      <section className="card-surface p-5 sm:p-8 mb-6" data-testid="payment-section">
        <h2 className="font-serif text-2xl mb-2">Plata online (Stripe)</h2>
        <p className="text-xs mb-6" style={{ color: "var(--brand-text-secondary)" }}>
          Clientul poate plati un avans online dupa aprobarea rezervarii. Restul se plateste offline catre proprietar.
        </p>
        <label className="flex items-center gap-2 mb-4 text-sm cursor-pointer">
          <input type="checkbox" checked={!!settings.payment?.enabled} onChange={(e) => setSettings({...settings, payment: {...(settings.payment||{}), enabled: e.target.checked}})} data-testid="payment-enabled" />
          Activeaza plata online
        </label>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
          <Input label="% Avans" type="number" value={settings.payment?.deposit_pct ?? 30} onChange={(v) => setSettings({...settings, payment: {...(settings.payment||{}), deposit_pct: v}})} testid="payment-deposit" />
          <div>
            <label className="label-eyebrow block mb-2">Valuta plata</label>
            <select className="brand-input" value={settings.payment?.currency || "EUR"} onChange={(e) => setSettings({...settings, payment: {...(settings.payment||{}), currency: e.target.value}})} data-testid="payment-currency">
              <option value="EUR">EUR</option>
              <option value="RON">RON</option>
            </select>
          </div>
        </div>
        <button onClick={savePayment} className="btn-gold-filled" data-testid="save-payment">Salveaza plata</button>
      </section>

      {/* Reservation fields */}
      <section className="card-surface p-5 sm:p-8" data-testid="reservation-fields-section">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-serif text-2xl">Campuri formular rezervare</h2>
          <button onClick={() => setSettings({...settings, reservation_fields: [...(settings.reservation_fields||[]), {key:`field_${Date.now()}`, label_ro:"", label_en:"", type:"text", required:false}]})} className="btn-ghost text-xs" data-testid="add-res-field">+ Adauga camp</button>
        </div>
        {(settings.reservation_fields || []).map((f, idx) => (
          <div key={idx} className="grid grid-cols-1 sm:grid-cols-12 gap-2 mb-3 items-center" data-testid={`res-field-${idx}`}>
            <input className="brand-input sm:col-span-2 text-xs" placeholder="Key" value={f.key} onChange={(e) => { const c=[...settings.reservation_fields]; c[idx]={...c[idx], key:e.target.value}; setSettings({...settings, reservation_fields:c}); }} />
            <input className="brand-input sm:col-span-3 text-xs" placeholder="Eticheta RO" value={f.label_ro} onChange={(e) => { const c=[...settings.reservation_fields]; c[idx]={...c[idx], label_ro:e.target.value}; setSettings({...settings, reservation_fields:c}); }} />
            <input className="brand-input sm:col-span-3 text-xs" placeholder="Eticheta EN" value={f.label_en} onChange={(e) => { const c=[...settings.reservation_fields]; c[idx]={...c[idx], label_en:e.target.value}; setSettings({...settings, reservation_fields:c}); }} />
            <select className="brand-input sm:col-span-2 text-xs" value={f.type} onChange={(e) => { const c=[...settings.reservation_fields]; c[idx]={...c[idx], type:e.target.value}; setSettings({...settings, reservation_fields:c}); }}>
              <option value="text">text</option>
              <option value="textarea">textarea</option>
            </select>
            <label className="sm:col-span-1 text-xs flex items-center gap-1"><input type="checkbox" checked={f.required} onChange={(e) => { const c=[...settings.reservation_fields]; c[idx]={...c[idx], required:e.target.checked}; setSettings({...settings, reservation_fields:c}); }} /> req</label>
            <button onClick={() => setSettings({...settings, reservation_fields: settings.reservation_fields.filter((_,i)=>i!==idx)})} className="btn-ghost sm:col-span-1"><Trash2 className="w-3 h-3" /></button>
          </div>
        ))}
        <button onClick={saveReservationFields} className="btn-gold-filled mt-4" data-testid="save-res-fields">Salveaza campuri</button>
      </section>
    </>
  );
}
